var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxSelectedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 2,
    fill: "#2070EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65237 11.5398C7.12202 10.9034 6.17618 10.8174 5.53976 11.3477C4.90335 11.8781 4.81736 12.8239 5.34771 13.4603L7.84771 16.4603C8.37587 17.0941 9.31674 17.1824 9.9536 16.6579L18.4536 9.65794C19.0931 9.1313 19.1846 8.18597 18.6579 7.54648C18.1313 6.90699 17.186 6.81551 16.5465 7.34215L9.19766 13.3941L7.65237 11.5398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSelectedBlue);
export default __webpack_public_path__ + "static/media/checkbox-selected-blue.52bbc391163f7edd2b8fac5f41f6737e.svg";
export { ForwardRef as ReactComponent };